export default __webpack_public_path__ + "static/media/addOnsTab.8837061a.svg";